import { Login } from './Login.js';

function App() {
   return (
      <div className="App">
         <header className="App-header">
            <Login/>
         </header>
      </div>
   );
}

export default App;
